export enum Direction {
    IN = 'in',
    OUT = 'out',
}
